import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef, createElement } from 'react';
import cn from 'classnames';
import { Icon } from '../Icon/Icon.js';
import { Button } from '../Button/Button.js';

var _excluded = ["icon", "rounded"];
var IconButton = /*#__PURE__*/forwardRef(function IconButton(props, ref) {
  var icon = props.icon,
      _props$rounded = props.rounded,
      rounded = _props$rounded === void 0 ? false : _props$rounded,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded);

  var className = cn('yt-button--icon', {
    'yt-button--icon--rounded': rounded
  }, props.className);

  if (!icon) {
    return null;
  }

  return createElement(Button, Object.assign({}, otherProps, {
    className: className,
    ref: ref
  }), createElement(Icon, {
    name: icon
  }));
});

export { IconButton };
//# sourceMappingURL=IconButton.js.map
